export default {
  "pages.layouts.userLayout.title": "OurWork - 外国人材管理",
  "pages.login.success": "ログイン成功",
  "pages.login.failure": "ログイン失敗。もう一度お試しください",
  "pages.login.username.placeholder": "ユーザー名",
  "pages.login.username.required": "ユーザー名を入力してください",
  "pages.login.password.placeholder": "パスワード",
  "pages.login.password.required": "パスワードを入力してください",
  "pages.login.noAccount": "アカウントをお持ちでない方",
  "pages.login.goRegister": "新規登録",
  "pages.register.title": "新規登録",
  "pages.register.subtitle": "OurWorkアカウントを作成",
  "pages.register.success": "登録完了",
  "pages.register.failure": "登録に失敗しました。もう一度お試しください",
  "pages.register.username.placeholder": "ユーザー名（3文字以上）",
  "pages.register.username.required": "ユーザー名を入力してください",
  "pages.register.username.min": "ユーザー名は3文字以上で入力してください",
  "pages.register.displayName.placeholder": "表示名（任意）",
  "pages.register.password.placeholder": "パスワード（6文字以上）",
  "pages.register.password.required": "パスワードを入力してください",
  "pages.register.password.min": "パスワードは6文字以上で入力してください",
  "pages.register.confirmPassword.placeholder": "パスワード確認",
  "pages.register.confirmPassword.required": "パスワードを再入力してください",
  "pages.register.confirmPassword.mismatch": "パスワードが一致しません",
  "pages.register.submit": "登録",
  "pages.register.hasAccount": "既にアカウントをお持ちの方",
  "pages.register.goLogin": "ログイン",
  "pages.404.subTitle": "ページが見つかりません",
  "pages.404.buttonText": "ホームに戻る",

  // 共通
  "pages.common.actions": "操作",
  "pages.common.edit": "編集",
  "pages.common.delete": "削除",
  "pages.common.detail": "詳細",
  "pages.common.save": "保存",
  "pages.common.submit": "作成",
  "pages.common.cancel": "キャンセル",
  "pages.common.confirm": "確認",
  "pages.common.select": "選択してください",
  "pages.common.prev": "前へ",
  "pages.common.next": "次へ",
  "pages.common.remark": "備考",
  "pages.common.createSuccess": "作成しました",
  "pages.common.updateSuccess": "更新しました",
  "pages.common.deleteSuccess": "削除しました",
  "pages.common.confirmDelete": "削除してもよろしいですか？",
  "pages.common.noData": "データなし",

  // ダッシュボード
  "pages.dashboard.totalCases": "案件総数",
  "pages.dashboard.activeTasks": "進行中タスク",
  "pages.dashboard.overdueTasks": "期限超過タスク",
  "pages.dashboard.expiringResidence": "在留期限到来",
  "pages.dashboard.upcomingTasks": "近日のタスク",
  "pages.dashboard.expiringTalents": "在留期限到来の対象者",
  "pages.dashboard.noTasks": "タスクはありません",
  "pages.dashboard.noAlerts": "アラートはありません",
  "pages.dashboard.calendar": "カレンダー",
  "pages.dashboard.calendar.taskDeadline": "タスク期限",
  "pages.dashboard.calendar.residenceExpiry": "在留期限",
  "pages.dashboard.calendar.eventDue": "イベント期限",
  "pages.dashboard.calendar.entryDate": "入国予定日",
  "pages.dashboard.calendar.contractDate": "契約日",
  "pages.dashboard.calendar.noEvents": "予定なし",

  // 案件
  "pages.case.caseNumber": "案件番号",
  "pages.case.talentName": "対象者",
  "pages.case.companyName": "受入企業",
  "pages.case.status": "ステータス",
  "pages.case.status.active": "進行中",
  "pages.case.status.completed": "完了",
  "pages.case.status.suspended": "中断",
  "pages.case.progress": "進捗",
  "pages.case.assignee": "担当者",
  "pages.case.createdAt": "作成日",
  "pages.case.create": "案件を作成",
  "pages.case.residenceStatus": "在留資格",
  "pages.case.residenceExpiry": "在留期限",
  "pages.case.program": "制度区分",
  "pages.case.program.technicalIntern": "技能実習",
  "pages.case.program.specifiedSkilled": "特定技能",
  "pages.case.program.trainingEmployment": "育成就労",
  "pages.case.internStage": "号数",
  "pages.case.internStage.1": "第1号",
  "pages.case.internStage.2": "第2号",
  "pages.case.internStage.3": "第3号",
  "pages.case.practicalStartDate": "実習開始日",
  "pages.case.fieldCode": "分野",
  "pages.case.fieldCode.construction": "建設",
  "pages.case.fieldCode.food": "食品製造",
  "pages.case.fieldCode.nursing": "介護",
  "pages.case.fieldCode.agriculture": "農業",
  "pages.case.fieldCode.fishing": "漁業",
  "pages.case.fieldCode.manufacturing": "製造業",
  "pages.case.fieldCode.lodging": "宿泊",
  "pages.case.fieldCode.restaurant": "外食",
  "pages.case.fieldCode.cleaning": "ビルクリーニング",
  "pages.case.fieldCode.other": "その他",
  "pages.case.startDate": "案件開始日",
  "pages.case.endDate": "案件終了日",
  "pages.case.step.talent": "対象者選択",
  "pages.case.step.talent.title": "対象者を選択してください",
  "pages.case.step.talent.desc": "案件に紐付ける対象者を検索・選択します。",
  "pages.case.step.talent.search": "氏名・在留カード番号で検索...",
  "pages.case.step.talent.add": "新規登録",
  "pages.case.step.company": "受入企業選択",
  "pages.case.step.company.title": "受入企業を選択してください",
  "pages.case.step.company.desc": "案件に紐付ける受入企業を検索・選択します。",
  "pages.case.step.company.search": "企業名・法人番号で検索...",
  "pages.case.step.company.add": "新規登録",
  "pages.case.step.details": "案件詳細入力",
  "pages.case.step.details.title": "案件詳細を入力してください",
  "pages.case.step.details.desc": "制度区分・分野などの詳細情報を設定します。",
  "pages.company.name": "企業名",
  "pages.company.corporateNumber": "法人番号",
  "pages.company.industry": "業種",
  "pages.company.contact": "連絡先",
  "pages.case.tab.info": "基本情報",
  "pages.case.tab.tasks": "タスク",
  "pages.case.tab.timeline": "タイムライン",
  "pages.case.tab.export": "エクスポート",
  "pages.case.section.caseInfo": "案件情報",
  "pages.case.section.talentInfo": "対象者情報",
  "pages.case.section.companyInfo": "受入企業情報",
  "pages.case.companyFilter": "受入企業",
  "pages.case.companyFilter.placeholder": "企業を選択",
  "pages.case.assigneeFilter": "担当者",
  "pages.case.assigneeFilter.placeholder": "担当者を選択",
  "pages.case.assign": "担当アサイン",
  "pages.case.assignSuccess": "担当者を変更しました",
  "pages.case.assignError": "担当者の変更に失敗しました",
  "pages.case.assignModal.title": "担当者アサイン",
  "pages.case.assignModal.desc": "の担当者を選択してください",
  "pages.case.noTasks": "タスクはありません",
  "pages.case.validate.talentRequired": "対象者の選択は必須です",
  "pages.case.validate.companyRequired": "受入企業の選択は必須です",
  "pages.task.status.overdue": "超過",
  "pages.task.name": "タスク名",
  "pages.task.type": "タイプ",
  "pages.task.dueDate": "期限",
  "pages.task.status": "ステータス",
  "pages.task.markDone": "完了",
  "pages.case.taskCompleted": "タスクを完了しました",
  "pages.case.taskCompleteError": "タスクの完了に失敗しました",
  "pages.case.taskCompleteModal.title": "タスク完了",
  "pages.case.taskCompleteModal.desc":
    "タスクを完了するには、支援記録IDを入力してください。",
  "pages.case.taskCompleteModal.recordId": "支援記録ID",
  "pages.case.detail.talentNameRomaji": "氏名（ローマ字）",
  "pages.task.caseNumber": "案件番号",
  "pages.task.stat.total": "全タスク",
  "pages.task.stat.pending": "未着手",
  "pages.task.stat.overdue": "超過",
  "pages.task.stat.completed": "完了",
  "pages.task.status.pending": "未着手",
  "pages.task.status.inProgress": "進行中",
  "pages.task.status.done": "完了",

  // 対象者
  "pages.talent.name": "氏名",
  "pages.talent.nameRomaji": "ローマ字",
  "pages.talent.nationality": "国籍",
  "pages.talent.residenceStatus": "在留資格",
  "pages.talent.residenceExpiry": "在留期限",
  "pages.talent.residenceCardNo": "在留カード番号",
  "pages.talent.passportNo": "パスポート番号",
  "pages.talent.phone": "電話番号",
  "pages.talent.email": "メール",
  "pages.talent.address": "住所",
  "pages.talent.gender": "性別",
  "pages.talent.birthDate": "生年月日",
  "pages.talent.nativeLanguage": "母語",
  "pages.talent.create": "対象者を追加",
  "pages.talent.edit": "対象者を編集",
  "pages.talent.tab.basic": "基本情報",
  "pages.talent.tab.emergency": "緊急連絡先",
  "pages.talent.nameKana": "名前（ヨミガナ）",
  "pages.talent.birthPlace": "出生地",
  "pages.talent.homeCountryAddress": "本国における住居地",
  "pages.talent.passportExpiry": "パスポート期限",
  "pages.talent.visaCategory": "ビザ区分",
  "pages.talent.age": "歳",
  "pages.talent.spouseStatus": "配偶者",
  "pages.talent.jobInJapan": "日本国内での職業",
  "pages.talent.mobilePhone": "携帯電話番号",
  "pages.talent.enrollmentStatus": "在籍状況",
  "pages.talent.managedByOtherUnionName": "他組合名",
  "pages.talent.difficultyReportDate": "困難時届出日",
  "pages.talent.plannedReturnDate": "帰国予定日",
  "pages.talent.midtermReturnDate": "途中帰国・失踪日",
  "pages.talent.trainingRestartDate": "実習再開日",
  "pages.talent.transferHistory": "実習中の移籍歴",
  "pages.talent.transferDate": "移籍日",
  "pages.talent.newSystemFlag": "新制度対応",
  "pages.talent.newSystemStartDate": "新制度開始日",
  "pages.talent.fullReturnDate": "満了帰国日",
  "pages.talent.traineeCategory": "技能実習生区分",
  "pages.talent.status": "ステータス",
  "pages.talent.identificationCode": "管理番号",
  "pages.talent.photo": "証明写真",
  "pages.talent.step.basic": "基本情報",
  "pages.talent.step.contact": "連絡先",
  "pages.talent.step.residence": "在留・パスポート",
  "pages.talent.step.confirm": "確認",
  "pages.talent.editDraft": "対象者を編集",
  "pages.talent.saveDraft": "下書き保存",
  "pages.talent.draftSaved": "下書きを保存しました",
  "pages.talent.emergencyName": "氏名",
  "pages.talent.emergencyRelation": "関係",
  "pages.talent.emergencyPhone": "電話番号",
  "pages.talent.tab.training": "実習情報",
  "pages.talent.tab.training.saveSuccess": "実習情報を保存しました",

  // 実習先情報
  "pages.placement.title": "実習先情報",
  "pages.placement.sendingOrg": "送り出し機関名",
  "pages.placement.implementingCompany": "実施者",
  "pages.placement.workplaceName": "勤務先名称",
  "pages.placement.workplaceNote":
    "※実習実施場所が選択した事業所と異なる場合は記入してください",
  "pages.placement.groupName": "所属グループ",
  "pages.placement.accommodationName": "宿泊施設",
  "pages.placement.postalCode": "郵便番号",
  "pages.placement.addressLookup": "住所表示",
  "pages.placement.addressCandidate": "所在地候補",
  "pages.placement.address": "住所",
  "pages.placement.occupationTitle": "技能実習の内容",
  "pages.placement.occupationNote": "※全ての職種を選択してください",
  "pages.placement.occupation1": "移行職種①",
  "pages.placement.occupation2": "移行職種②　※",
  "pages.placement.occupation3": "移行職種③　※",
  "pages.placement.occupationOther": "移行職種以外の場合",
  "pages.placement.occupationNoTitle": "実習生職種番号",
  "pages.placement.primaryOccupationNo": "主たる職種番号",
  "pages.placement.subOccupation1": "他職種1",
  "pages.placement.subOccupation2": "他職種2",
  "pages.placement.subOccupation3": "他職種3",

  // 実習期間情報
  "pages.placement.periodTitle": "実習期間情報",
  "pages.placement.homeDepartureDate": "母国出国日",
  "pages.placement.plannedEntryDate": "入国予定日",
  "pages.placement.actualEntryDate": "入国日",
  "pages.placement.phase3StartDate": "3号実習開始日（3号入国日）",
  "pages.placement.tempReturnPeriod": "一時帰国期間",
  "pages.placement.preEntryTraining": "入国前講習の有無",
  "pages.placement.preEntryTraining.yes": "有",
  "pages.placement.preEntryTraining.no": "無",
  "pages.placement.trainingFacility": "講習施設",
  "pages.placement.postEntryTrainingPeriod": "入国後講習期間",
  "pages.placement.phase1": "実習1号",
  "pages.placement.phase2": "実習2号",
  "pages.placement.phase3": "実習3号",
  "pages.placement.approvalDate": "認定日",
  "pages.placement.approvalNumber": "認定番号",
  "pages.placement.trainingPeriod": "実施期間",
  "pages.placement.phaseRemark": "その他備考・メモ欄に反映",
  "pages.placement.hasFixedContract": "雇用契約期間の定め",
  "pages.placement.hasFixedContract.yes": "有",
  "pages.placement.hasFixedContract.no": "無",
  "pages.placement.contractPeriod": "雇用契約期間",
  "pages.placement.subCategory": "技能実習生区分",
  "pages.placement.enrollmentStatus": "ステータス",
  "pages.placement.categoryStatus": "区分・ステータス",

  // タブ
  "pages.talent.tab.visa": "ビザ・在留",
  "pages.talent.tab.employer": "雇用主情報",
  "pages.talent.tab.support": "支援記録",

  // 企業
  "pages.company.name": "企業名",
  "pages.company.corporateNumber": "法人番号",
  "pages.company.representative": "代表者",
  "pages.company.industry": "業種",
  "pages.company.contactName": "担当者",
  "pages.company.contactPhone": "電話番号",
  "pages.company.contactEmail": "メール",
  "pages.company.address": "住所",
  "pages.company.create": "企業を追加",
  "pages.company.edit": "企業を編集",
  "pages.company.detail": "企業詳細",

  // タスク
  "pages.task.taskName": "タスク名",
  "pages.task.taskType": "種類",
  "pages.task.type.guidance": "事前ガイダンス",
  "pages.task.type.interview": "定期面談",
  "pages.task.type.lifeSupport": "生活支援",
  "pages.task.type.document": "書類提出",
  "pages.task.type.other": "その他",
  "pages.task.status": "ステータス",
  "pages.task.status.pending": "未着手",
  "pages.task.status.inProgress": "進行中",
  "pages.task.status.done": "完了",
  "pages.task.status.skipped": "スキップ",
  "pages.task.dueDate": "期限日",
  "pages.task.completedAt": "完了日",
  "pages.task.markDone": "完了にする",
  "pages.task.confirmDone": "完了にしてもよろしいですか？",
  "pages.task.doneSuccess": "完了しました",

  // 支援記録
  "pages.record.caseId": "案件",
  "pages.record.case": "案件",
  "pages.record.conductedDate": "実施日",
  "pages.record.content": "内容",
  "pages.record.remark": "備考",
  "pages.record.createdAt": "作成日",
  "pages.record.create": "記録を作成",
  "pages.record.edit": "記録を編集",

  // 在留期限
  "pages.residence.expired": "期限切れ",
  "pages.residence.within30": "30日以内",
  "pages.residence.within60": "60日以内",
  "pages.residence.within90": "90日以内",
  "pages.residence.noAlerts": "なし",
  "pages.residence.talentId": "対象者",
  "pages.residence.currentExpiry": "現在の在留期限",
  "pages.residence.newExpiry": "新しい在留期限",
  "pages.residence.applicationDate": "申請日",
  "pages.residence.status": "ステータス",
  "pages.residence.status.pending": "未申請",
  "pages.residence.status.submitted": "申請中",
  "pages.residence.status.approved": "許可",
  "pages.residence.status.rejected": "不許可",
  "pages.residence.receiptNumber": "受理番号",
  "pages.residence.create": "記録を追加",
  "pages.residence.edit": "記録を編集",

  // ドキュメント
  "pages.document.fileName": "ファイル名",
  "pages.document.category": "分類",
  "pages.document.category.general": "一般",
  "pages.document.category.contract": "契約書",
  "pages.document.category.residence": "在留関連",
  "pages.document.category.certificate": "証明書",
  "pages.document.fileSize": "サイズ",
  "pages.document.createdAt": "アップロード日",
  "pages.document.upload": "アップロード",
  "pages.document.download": "ダウンロード",
  "pages.document.uploadSuccess": "アップロード完了",
  "pages.document.uploadError": "アップロード失敗",
  "pages.document.downloadError": "ダウンロード失敗",
  "pages.document.tab.uploadTitle": "文書をアップロード",
  "pages.document.tab.file": "ファイル",
  "pages.document.tab.selectFile": "ファイルを選択",
  "pages.document.category.application": "申請書",
  "pages.document.category.notification": "届出書",
  "pages.document.category.notice": "通知書",
  "pages.document.category.photo": "写真",
  "pages.document.category.other": "その他",

  // 対象者タブ
  "pages.talent.tab.documents": "文書",

  // イベント
  "pages.event.eventNumber": "イベント番号",
  "pages.event.eventType": "種類",
  "pages.event.type.correction": "補正",
  "pages.event.type.incident": "事故",
  "pages.event.type.complaint": "苦情",
  "pages.event.type.other": "その他",
  "pages.event.summary": "概要",
  "pages.event.resolution": "対応内容",
  "pages.event.status": "ステータス",
  "pages.event.status.open": "未対応",
  "pages.event.status.inProgress": "対応中",
  "pages.event.status.resolved": "解決済み",
  "pages.event.status.closed": "クローズ",
  "pages.event.occurredDate": "発生日",
  "pages.event.dueDate": "対応期限",
  "pages.event.caseId": "案件ID",
  "pages.event.create": "イベントを作成",
  "pages.event.edit": "イベントを編集",

  // エクスポート
  "pages.export.jobNumber": "ジョブ番号",
  "pages.export.exportType": "種類",
  "pages.export.type.casePack": "個別証拠パック",
  "pages.export.type.periodPack": "定期届出パック",
  "pages.export.status": "ステータス",
  "pages.export.createdAt": "作成日",
  "pages.export.finishedAt": "完了日",
  "pages.export.download": "ダウンロード",
  "pages.export.downloadError": "ダウンロード失敗",
  "pages.export.casePack": "個別証拠パック",
  "pages.export.periodPack": "定期届出パック",
  "pages.export.caseId": "案件ID",
  "pages.export.startDate": "開始日",
  "pages.export.endDate": "終了日",
  "pages.export.createSuccess": "エクスポートジョブを作成しました",

  // プラン
  "pages.plan.planName": "プラン名",
  "pages.plan.status": "ステータス",
  "pages.plan.currentPeriodEnd": "次回更新日",
  "pages.plan.caseUsage": "案件数",
  "pages.plan.userUsage": "ユーザー数",
  "pages.plan.storageUsage": "ストレージ",
  "pages.plan.upgrade": "プランをアップグレード",
  "pages.plan.paymentHistory": "支払い履歴",
  "pages.plan.upgradeSuccess": "アップグレード完了",
  "pages.plan.upgradeError": "アップグレード失敗",
  "pages.plan.free": "無料",
  "pages.plan.currentPlan": "現在のプラン",
  "pages.plan.selectPlan": "このプランを選択",
  "pages.plan.caseLimit": "案件上限",
  "pages.plan.userLimit": "ユーザー上限",
  "pages.plan.storageLimit": "ストレージ容量",

  // 支払い
  "pages.payment.paidAt": "支払日",
  "pages.payment.description": "内容",
  "pages.payment.amount": "金額",
  "pages.payment.status": "ステータス",
  "pages.payment.status.paid": "支払い済み",
  "pages.payment.status.pending": "未払い",
  "pages.payment.status.failed": "失敗",
  "pages.payment.invoice": "請求書",
  "pages.payment.viewInvoice": "請求書を表示",

  // 設定
  "pages.settings.tab.profile": "プロフィール",
  "pages.settings.tab.password": "パスワード変更",
  "pages.settings.tab.orgInfo": "組織情報",
  "pages.settings.tab.members": "メンバー管理",
  "pages.settings.username": "ユーザー名",
  "pages.settings.email": "メール",
  "pages.settings.nickname": "表示名",
  "pages.settings.phone": "電話番号",
  "pages.settings.profileUpdated": "プロフィールを更新しました",
  "pages.settings.oldPassword": "現在のパスワード",
  "pages.settings.newPassword": "新しいパスワード",
  "pages.settings.confirmPassword": "パスワード確認",
  "pages.settings.changePassword": "パスワードを変更",
  "pages.settings.passwordChanged": "パスワードを変更しました",
  "pages.settings.passwordMismatch": "パスワードが一致しません",
  "pages.settings.teamSettings": "チーム管理",
  "pages.settings.orgName": "組織名",
  "pages.settings.legalName": "法人名",
  "pages.settings.address": "住所",
  "pages.settings.memberName": "氏名",
  "pages.settings.memberEmail": "メール",
  "pages.settings.memberRole": "役割",
  "pages.settings.memberStatus": "ステータス",
  "pages.settings.status.active": "有効",
  "pages.settings.status.invited": "招待中",
  "pages.settings.status.disabled": "無効",
  "pages.settings.inviteMember": "メンバーを招待",
  "pages.settings.inviteEmail": "メールアドレス",
  "pages.settings.inviteRole": "役割",
  "pages.settings.inviteSuccess": "招待を送信しました",
  "pages.settings.removeMember": "削除",
  "pages.settings.confirmRemove": "このメンバーを削除してもよろしいですか？",
  "pages.settings.credentialModal.title": "アカウント作成完了",
  "pages.settings.credentialModal.desc":
    "以下のログイン情報をメンバーにお伝えください。初回ログイン時にパスワードの変更が求められます。",
  "pages.settings.credentialModal.username": "ユーザー名（メール）",
  "pages.settings.credentialModal.password": "仮パスワード",

  // パスワード変更（初回ログイン）
  "changeInitialPassword.title": "パスワードを変更",
  "changeInitialPassword.hint":
    "セキュリティのため、初回ログイン時にパスワードを変更してください",
  "changeInitialPassword.new": "新しいパスワード",
  "changeInitialPassword.confirm": "パスワード確認",
  "changeInitialPassword.submit": "変更する",
  "changeInitialPassword.skip": "後で変更する",
  "changeInitialPassword.success": "パスワードを変更しました",
  "settings.password.minLength": "パスワードは6文字以上で入力してください",

  // ページタイトル
  "pages.login.title": "ログイン",
  "pages.dashboard.title": "ダッシュボード",
  "pages.case.list": "案件一覧",
  "pages.case.detail": "案件詳細",
  "pages.talent.list": "対象者一覧",
  "pages.company.list": "企業一覧",
  "pages.task.list": "タスク一覧",
  "pages.task.create": "タスク作成",
  "pages.task.createSuccess": "タスクを作成しました",
  "pages.record.guidanceTitle": "事前ガイダンス",
  "pages.record.interviewTitle": "定期面談",
  "pages.record.lifeSupportTitle": "生活支援記録",
  "pages.residence.alertTitle": "期限アラート",
  "pages.residence.historyTitle": "更新記録",
  "pages.document.list": "文書一覧",
  "pages.event.list": "イベント一覧",
  "pages.export.list": "エクスポート一覧",
  "pages.settings.title": "設定",
  "pages.plan.upgradeTitle": "プランアップグレード",

  // フィードバック
  "feedback.title": "フィードバック",
  "feedback.tooltip": "フィードバック",
  "feedback.submit": "送信",
  "feedback.submitSuccess": "フィードバックを送信しました",
  "feedback.submitError": "送信に失敗しました",
  "feedback.category": "カテゴリ",
  "feedback.category.bug": "バグ報告",
  "feedback.category.feature": "機能リクエスト",
  "feedback.category.suggestion": "ご意見・ご要望",
  "feedback.content": "内容",
  "feedback.contentRequired": "内容を入力してください",
  "feedback.contactEmail": "連絡先メール（任意）",
  "feedback.emailInvalid": "メールアドレスの形式が正しくありません",
};
